/* tslint:disable */
import * as Types from '../../../../../../graphql-api/gql-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type FindSlimProductQueryVariables = Types.Exact<{
  brandId: Types.Scalars['String']['input'];
  productId: Types.Scalars['String']['input'];
  includeRelatedProducts?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type FindSlimProductQuery = { findSlimProduct?: { articleTitle: string, title: string, productId: string, displayedProductId?: string | null, brandId: string, deliveryWindowType: Types.DeliveryWindowType, mainImageUrl?: string | null, isLocked?: boolean | null, neverOutOfStockType?: Types.NeverOutOfStockType | null, scaleSets?: { default: string, scales: any } | null, prepacks?: Array<{ productId: string, brandId: string, quantities: Array<{ quantity: number, productId: string }> }> | null, children?: Array<{ articleTitle: string, title: string, productId: string, displayedProductId?: string | null, brandId: string, parentId?: string | null, productType: Types.ProductType, isLocked?: boolean | null, mainImageUrl?: string | null, neverOutOfStockType?: Types.NeverOutOfStockType | null, children?: Array<{ productId: string, attributes: any, masterAttributes: any }> | null }> | null, media: Array<{ url: string, urls?: Array<string> | null, type: Types.MediaType }> } | null };

export const FindSlimProductDocument = gql`
    query findSlimProduct($brandId: String!, $productId: String!, $includeRelatedProducts: Boolean) {
  findSlimProduct(
    brandId: $brandId
    productId: $productId
    includeRelatedProducts: $includeRelatedProducts
  ) {
    articleTitle
    title
    productId
    displayedProductId
    brandId
    deliveryWindowType
    mainImageUrl
    scaleSets {
      default
      scales
    }
    prepacks {
      productId
      brandId
      quantities {
        quantity
        productId
      }
    }
    children {
      articleTitle
      title
      productId
      displayedProductId
      brandId
      parentId
      productType
      isLocked
      mainImageUrl
      children {
        productId
        attributes
        masterAttributes
      }
      neverOutOfStockType
    }
    isLocked
    media {
      url
      urls
      type
    }
    neverOutOfStockType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FindSlimProductGQL extends Apollo.Query<FindSlimProductQuery, FindSlimProductQueryVariables> {
    document = FindSlimProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }